import axios from 'axios';
import { getAccessToken } from './token';
const api = axios.create({ baseURL: process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080/api', withCredentials: false });
api.interceptors.request.use(async config => { const token = await getAccessToken(); config.headers = config.headers || {}; if (token) config.headers.Authorization = `Bearer ${token}`; else delete config.headers.Authorization; return config; });
api.interceptors.response.use(response => { response.ok = response.status >= 200 && response.status < 300; response.json = async () => response.data; return response; });
export default api;
